<script setup>
import OverviewSparkline from './OverviewSparkline.vue'
import OverviewDeltaBadge from './OverviewDeltaBadge.vue'

defineProps({
    label: { type: String, required: true },
    kpi:   { type: Object, required: true },
    // kpi: { value, unit?, delta, trend[], flag? }
})
</script>

<template>
    <div
        class="bg-white dark:bg-neutral-900 border border-gray-100 dark:border-neutral-800 rounded-2xl p-4 pb-3 flex flex-col gap-2 relative overflow-hidden"
    >
        <!-- Top row: icon + label -->
        <div class="flex items-center gap-2">
            <div
                class="w-[30px] h-[30px] rounded-[9px] flex items-center justify-center flex-shrink-0"
                :class="kpi.flag ? 'bg-orange-50 dark:bg-orange-950 text-[#D9663A] dark:text-orange-400' : 'bg-blue-50 dark:bg-blue-950 text-blue-600 dark:text-blue-400'"
            >
                <slot name="icon"/>
            </div>
            <div class="text-[11.5px] text-gray-500 dark:text-neutral-400 font-semibold leading-tight">{{ label }}</div>
        </div>

        <!-- Value -->
        <div class="text-[30px] font-bold tracking-tight text-gray-900 dark:text-white leading-none flex items-baseline gap-1">
            {{ kpi.value.toLocaleString('cs') }}
            <span v-if="kpi.unit" class="text-base font-semibold text-gray-400 dark:text-neutral-500">{{ kpi.unit }}</span>
        </div>

        <!-- Footer: delta + sparkline -->
        <div class="flex items-center justify-between gap-2 mt-0.5">
            <OverviewDeltaBadge :delta="kpi.delta"/>
            <OverviewSparkline
                v-if="kpi.trend?.length"
                :data="kpi.trend"
                :color="kpi.flag ? '#D9663A' : '#2A6FDB'"
            />
        </div>
    </div>
</template>
